export function arrayDiff(a, b) {
  return [
      ...a.filter(x => !b.includes(x)),
      ...b.filter(x => !a.includes(x))
  ]
}
